import React from 'react';

const AboutHome = () => {
    return (
        <div className="about_us_home">
            <div className="about_us_inner bg_image_10">
                <div className="spin_logo d-none d-lg-block">
                    <img src="images/about/layer5.svg" alt="" className="linear_logo" />
                    <img src="images/about/layer6.svg" alt="" className="circle_logo" />
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="section_header">
                            <h2 className="section_title">About Us</h2>
                            <h6 className="section_sub_title">Hungrybuzz cooks food as a culnery Art</h6>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                tempor incididunt ut labore et dolore magna aliqua. Ut en
                                ad minim veniam, quis nostrud exercitation ullamco lab
                                aliquip ex ea commodo consequat. Penat.</p>
                            <div className="button_group">
                                <a className="button">Learn More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about_imgbox">
                            <div className="layer_spice_1"><img src="images/about/layer3.png" alt="" className="src" /></div>
                            <div className="layer_spice_2"><img src="images/about/layer4.png" alt="" className="src" /></div>
                            <img src="images/about/6.jpg" alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutHome;